export interface CleanupRow {
  flightId: string;
  actDepTime?: number | string;
  actArrTime?: number | string;
}

// Rows the 3-day cleanup may remove.
// It keeps the active flight, and a departed flight while a timer runs.
export function flightsToPurge<T extends CleanupRow>(
  rows: T[],
  activeFlightId: string | undefined,
  timerRunning: boolean
): T[] {
  return rows.filter((row) => {
    if (activeFlightId && row.flightId === activeFlightId) return false;
    if (timerRunning && Number(row.actDepTime) > 0 && !(Number(row.actArrTime) > 0)) return false;
    return true;
  });
}
